
//Execution and Phase share status types
export enum ExecutionStatusType {

    Unexecuted = "unexecuted",
    Queued = "queued", //201
    Pending = "pending",
    Throttled = "throttled", //202
    Running = "running",
    Succeeded = "succeeded",
    Cancelled = "cancelled",
    Rejected = "rejected",
    Timeout = "timeout",
    Failed = "failed",
    Unknown = "unknown"

}


export const getColorForExecutionStatusType = (statusType: ExecutionStatusType) => {

    switch (statusType) {
        case ExecutionStatusType.Queued:
        case ExecutionStatusType.Unknown:
        case ExecutionStatusType.Cancelled:
        case ExecutionStatusType.Rejected:
        default:
            return 'bg-gray-500';
        case ExecutionStatusType.Pending:
            return 'bg-yellow-500';
        case ExecutionStatusType.Throttled:
        case ExecutionStatusType.Timeout:
            return 'bg-orange-500';
        case ExecutionStatusType.Running:
            return 'bg-blue-500';
        case ExecutionStatusType.Succeeded:
            return 'bg-brand-green';
        case ExecutionStatusType.Failed:
            return 'bg-[#ff5757]';
    }

}